
<div>
  <div class="col-md-12 col-lg-12">
    <div class="col-sm-3"><h4><b>{{label}}</b></h4></div>
    <div [@openClose]="!isOpen ? 'open' : 'closed'">
      <div class="col-sm-3"><h4>{{selectedValue?.key}}</h4></div>
      <div class="col-sm-3"><h4 class="change {{enableChange? '':'disabled'}}" (click)="change()">{{ 'common.change' | translate }}</h4></div>
    </div>
  </div>
</div>

<div *ngIf="isOpen" >
  <div class="col-md-4 col-sm-10">
    <div class="dropdown {{showDdl ? 'open' : ''}}">
      <div class="inner-addon right-addon">
        <i class="glyphicon armx-sort"></i>
        <input type="text" class="form-control" input-Foucs (onInputFocus)="triggerFoucs($event)" placeholder="search" (input)="search($event)" [(ngModel)]="searchTerm" />
      </div>
      <ul class="dropdown-menu" >
        <li *ngFor="let item of tempContent; index as i"
            class="{{i==arrowkeyLocation? 'active' :''}}"><a (click)="selectCountryDDL(item)" >{{item.value}} - {{item.key}}</a></li>
      </ul>
    </div>
  </div>
</div>

